import { createSelector } from 'react-sweet-state';

import type { FormFields } from '../../../../common/types/form/form-fields';
import type {
	FieldValue,
	FieldValues,
	ModifiedFieldValues,
} from '../../../../common/types/form/form-fields/field-values';
import { asModifiedFilesValue } from '../../../../common/types/form/form-fields/field-values/utils';
import type { FormRendererState } from '../../types';

/*
 * Selector to get the current values of all form fields
 * This combines the form fields with any unsaved modified values
 */
export const currentValuesSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	FieldValues
> = createSelector(
	(state: FormRendererState) => state.formFields,
	(state: FormRendererState) => state.modifiedValues,
	(formFields: FormFields, modifiedValues: ModifiedFieldValues) =>
		Object.keys(formFields).reduce((currentValues, fieldId) => {
			const modifiedFieldValue = modifiedValues[fieldId];
			const modifiedFilesValue = asModifiedFilesValue(modifiedFieldValue);
			const sanitisedModifiedValue: FieldValue | null | undefined =
				modifiedFilesValue === undefined
					? modifiedFieldValue
					: modifiedFilesValue === null
						? null
						: { files: modifiedFilesValue.files };
			const currentValue =
				sanitisedModifiedValue ||
				(sanitisedModifiedValue === null ? undefined : formFields[fieldId]?.value);
			return currentValue ? { ...currentValues, [fieldId]: currentValue } : currentValues;
		}, {} as FieldValues),
);
